import React from 'react';
import s from './SignalTranslation.module.scss';
import { FormattedMessage } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import InputNumber from '../WSAControls/InputNumber/InputNumber';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

const fixedDecimal = 2;

const SignalTranslationResults = ({ signalTranslationManager, setSignalTranslationResults, isViewMode, UpdateAllowed, intl }) => {
  const selectedSignalTranslation = signalTranslationManager.SelectedSignalTranslation;
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const addNewResult = () => {
    const resultsRowNew = {
      SignalTranslationId: selectedSignalTranslation.SignalTranslationId,
      SignalTranslationResultId: 0,
      GuidIdentifier: uuidv4(),
      Control: '',
      DesiredResult: null,
      PreCalResult: null,
      PostCalResult: null,
      isChanged: false,
      isDeleted: false,
      UpdatedBy: Cookies.get(`userid-${envName}`) || null
    };
    saveResultsHandler(resultsRowNew);
  };

  const calculateCalError = type => {
    let calError = '-';
    let calErrorValue = 0;
    let isZeroDetected = false;
    selectedSignalTranslation.SignalTranslationResults.map(result => {
      const resCalResult = CalError(result, type, true);
      if (resCalResult !== null) {
        if (parseInt(resCalResult) === 0) {
          isZeroDetected = true;
        }
        calErrorValue += resCalResult;
      }
    });
    if (calErrorValue > 0 || (calErrorValue === 0 && isZeroDetected)) {
      calError = (calErrorValue / selectedSignalTranslation.SignalTranslationResults.length).toFixed(fixedDecimal).toString() + '%';
    }

    return calError;
  };

  const saveResultsHandler = signalTranslationResult => {
    let listData = selectedSignalTranslation.SignalTranslationResults;

    if (signalTranslationResult.SignalTranslationResultId > 0) {
      const updatedData = listData.map(x => (x.GuidIdentifier === signalTranslationResult.GuidIdentifier ? { ...x, ...signalTranslationResult } : x));
      setSignalTranslationResults({
        SignalTranslationResults: updatedData
      });
    } else {
      let hasItem = listData.filter(item => {
        if (item.GuidIdentifier === signalTranslationResult.GuidIdentifier) return item;
      });

      if (hasItem.length > 0) {
        const updatedData = listData.map(x => (x.GuidIdentifier === signalTranslationResult.GuidIdentifier ? { ...x, ...signalTranslationResult } : x));
        setSignalTranslationResults({
          SignalTranslationResults: updatedData
        });
      } else {
        listData.push(signalTranslationResult);
        setSignalTranslationResults({
          SignalTranslationResults: listData
        });
      }
    }
  };

  return (
    <div className={s.signalTranslation}>
      <div className={s.contentWrapper}>
        <div className={s.signalTranslationResults}>
          <Row className={s.standardRow}>
            <Col sm={6} lg={8}>
              <h4 className={s.subheading}>
                <FormattedMessage id="signalTranslation.results" defaultMessage="Results" />
              </h4>
            </Col>
            <Col sm={6} lg={4}>
              {!isViewMode && (
                <Button
                  className={s.addbutton}
                  // style={WidgetVisibility(userProfileWidgets, 'SIGNALTRANSLATIONEQUATIONADD')}
                  onClick={addNewResult}
                  // disabled={disableMode}
                  data-unittest="addReultsButton"
                >
                  <FormattedMessage id="signalTranslation.addResults" defaultMessage="ADD NEW" />
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col className={s.tabContainer}>
              <Table variant className={`${s.wsInnerTable}`}>
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage id="signalTranslation.controlRange" defaultMessage="Control Range" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.desiredResults" defaultMessage="Desired Results" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.preCalResults" defaultMessage="Pre-Cal Results" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.error" defaultMessage="Error" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.postCalResults" defaultMessage="Post-Cal Results" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.error" defaultMessage="Error" />
                    </th>
                    <th className={s.emptyCol}></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {selectedSignalTranslation.SignalTranslationResults.map(resultsRow => {
                    if (resultsRow.isDeleted !== true) {
                      if (!isViewMode) {
                        return <ResultRow key={resultsRow.GuidIdentifier} resultRow={resultsRow} saveResults={saveResultsHandler} />;
                      } else {
                        return <ResultRowView key={resultsRow.GuidIdentifier} resultRow={resultsRow} />;
                      }
                    }
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className={s.preCalErrorRow}>
            <Col md={2} className={s.preCalErrorRowPadding}>
              <Form.Label>
                <FormattedMessage id="signalTranslation.preCalError" defaultMessage="Pre-Cal Error" />
              </Form.Label>
            </Col>
            <Col md={4}>
              <Form.Label>{calculateCalError('PRECAL')}</Form.Label>
            </Col>
          </Row>
          <Row className={s.postCalErrorRow}>
            <Col md={2} className={s.postCalErrorRowPadding}>
              <Form.Label>
                <FormattedMessage id="signalTranslation.postCalError" defaultMessage="Post-Cal Error" />
              </Form.Label>
            </Col>
            <Col md={4}>
              <Form.Label>{calculateCalError('POSTCAL')}</Form.Label>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SignalTranslationResults;

const CalError = (resultRow, type, resultTypeNumber = false) => {
  let errorPercentage = '';
  let errorPercentageValue = null;

  const divisibleDesiredResult = parseFloat(resultRow.DesiredResult) === 0 ? 1 : resultRow.DesiredResult;
  if (!divisibleDesiredResult) {
    return '-';
  }

  if (type === 'PRECAL') {
    if (resultRow.DesiredResult !== null && resultRow.PreCalResult) {
      const error = ((resultRow.DesiredResult - resultRow.PreCalResult) / divisibleDesiredResult) * 100;

      errorPercentageValue = Math.abs(error);
      errorPercentage =
        Math.abs(error)
          .toFixed(fixedDecimal)
          .toString() + '%';
    }
  }
  if (type === 'POSTCAL') {
    if (resultRow.DesiredResult !== null && resultRow.PostCalResult) {
      const error = ((resultRow.DesiredResult - resultRow.PostCalResult) / divisibleDesiredResult) * 100;
      errorPercentageValue = Math.abs(error);
      errorPercentage =
        Math.abs(error)
          .toFixed(fixedDecimal)
          .toString() + '%';
    }
  }
  if (resultTypeNumber) {
    return errorPercentageValue;
  } else {
    return errorPercentage;
  }
};

const ResultRow = ({ resultRow, saveResults }) => {
  const removeHandler = () => {
    saveResults({ ...resultRow, isDeleted: true });
  };

  const onChange = e => {
    saveResults({ ...resultRow, [e.target.name]: e.target.value, isChanged: true });
  };

  return (
    <tr>
      <td>
        <Form.Control type="text" name="Control" onChange={onChange} value={resultRow.Control} className={s.textInput} />
      </td>
      <td>
        <InputNumber
          name="DesiredResult"
          step=".1"
          onInputChange={onChange}
          customClassName={s.textResultInput}
          value={resultRow.DesiredResult?.toString()}
          id="formDesiredResult"
        />
      </td>
      <td>
        <InputNumber
          name="PreCalResult"
          step=".1"
          onInputChange={onChange}
          customClassName={s.textResultInput}
          value={resultRow.PreCalResult?.toString()}
          id="formPreCalResult"
        />
      </td>
      <td className={s.cellClass}>
        <div className={s.errorCalCell}>{CalError(resultRow, 'PRECAL')}</div>
      </td>
      <td>
        <InputNumber
          name="PostCalResult"
          step=".1"
          onInputChange={onChange}
          customClassName={s.textResultInput}
          value={resultRow.PostCalResult?.toString()}
          id="formPostCalResult"
        />
      </td>
      <td className={s.cellClass}>
        <div className={s.errorCalCell}> {CalError(resultRow, 'POSTCAL')} </div>
      </td>
      <td className={s.emptyCol}></td>
      <td className={s.cellClass}>
        <div className={s.errorCalCell}>
          <Button
            variant="outline-secondary"
            className={s.removeButton}
            href="#"
            onClick={removeHandler.bind(this)}
            data-unittest="changeData"
          >
            <FormattedMessage id="signalTranslation.remove" defaultMessage="Remove" />
          </Button>
        </div>
      </td>
    </tr>
  );
};

const ResultRowView = ({ resultRow }) => {
  return (
    <tr>
      <td>
        <div>{resultRow.Control}</div>
      </td>
      <td>
        <div>{resultRow.DesiredResult}</div>
      </td>
      <td>
        <div>{resultRow.PreCalResult}</div>
      </td>
      <td>
        <div>{CalError(resultRow, 'PRECAL')}</div>
      </td>
      <td>
        <div>{resultRow.PostCalResult}</div>
      </td>
      <td>{CalError(resultRow, 'POSTCAL')}</td>
      <td className={s.emptyCol}></td>
    </tr>
  );
};
